












import { Component, Prop, Vue } from 'vue-property-decorator';

import Input from '@/componentsV2/molecules/Inputs/TextField.vue';

@Component({
  components: {
    Input
  }
})
export default class DeactivationComment extends Vue {
  @Prop() changeComment!: Function;
  @Prop() comment!: string;

  get tPrefix() {
    return 'common.components.feedbackDisconnectV2';
  }
}
